import { StrictMode } from 'react';
import { createRoot, type Root } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { ApiError, initAuth, signIn } from './auth';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) =>
        // Conflicts and permission errors will not fix themselves.
        !(error instanceof ApiError && error.status < 500) && failureCount < 2,
      refetchOnWindowFocus: true,
    },
  },
});

const root: Root = createRoot(document.getElementById('root')!);

function SignIn() {
  return (
    <div className="center">
      <h1>Book a desk</h1>
      <p className="muted">Sign in with your Scatec account to continue.</p>
      <p>
        <button className="primary" onClick={() => void signIn()}>
          Sign in with Microsoft
        </button>
      </p>
    </div>
  );
}

function Broken({ message }: { message: string }) {
  return (
    <div className="center">
      <h1>Cannot start</h1>
      <p className="muted">{message}</p>
      <p>
        <button onClick={() => window.location.reload()}>Try again</button>
      </p>
    </div>
  );
}

initAuth()
  .then(({ signedIn }) => {
    if (!signedIn) {
      root.render(<SignIn />);
      return;
    }
    root.render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </StrictMode>,
    );
  })
  .catch((error: unknown) => {
    root.render(
      <Broken message={error instanceof Error ? error.message : 'Unknown error.'} />,
    );
  });
